import { render, staticRenderFns } from "./DashboardProducerPP.vue?vue&type=template&id=1bdbd591&"
import script from "./DashboardProducerPP.vue?vue&type=script&lang=js&"
export * from "./DashboardProducerPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports